export const BITBUCKET_PROVIDER_ID = 'bitbucket';
export const BITBUCKET_DVCS_NAME = 'Bitbucket';
export const BITBUCKET_PIPELINE_PROVIDER_ID = 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9';
export const BITBUCKET_PIPELINE_PROVIDER_ID_STG = 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N';
export const BITBUCKET_PIPELINE_PROVIDER_NAME = 'Bitbucket Pipelines';
export const JENKINS_PROVIDER_ID = 'jenkins';
export const JENKINS_NAME = 'Jenkins';
